import TuitionFeesContext from "src/context/tuitionFeesContext.js";
import { useTuitionFeesQuery } from "src/services/react-query-apis/get-tuition-fees";

const TuitionFeesProvider = ({ children, ...props }) => {
  const tuitionFeesQuery = useTuitionFeesQuery();
  const isLoaded = !tuitionFeesQuery.isPending;
  const list = tuitionFeesQuery.data?.data || [];

  // note praveen: used kaisuu since i couldnt come up with a better name for it, feel free to change it if you wish to
  const kaisuuOptionsList = regularClassId => {
    return list
      .filter(val => val.regular_class_id === regularClassId)
      .map(val => {
        return { ...val, value: val.times, label: val.times };
      });
  };

  const contextValues = {
    list,
    isLoaded,
    kaisuuOptionsList,
  };

  return (
    <TuitionFeesContext.Provider value={contextValues}>
      {children}
    </TuitionFeesContext.Provider>
  );
};

export default TuitionFeesProvider;
